import React from 'react';
import { Icon } from './Icon.js';
export const IconPhone = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2.95406 3.91886L3 3H9L10.5 8.5L8.5 10.5C9.11552 12.9621 11.0379 14.8845 13.5 15.5L15.5 13.5L21 15V21C11.0174 22.0508 2.4528 13.9441 2.95406 3.91886Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconPhone.js.map